import React from "react";
import { LOCAL_STORE_JWT } from "../utils/main";

let initialState = { loggedin: false, user: {}, loaded: false, signin: false };

const UserContext = React.createContext();

let reducer = (state, action) => {
  // console.log("action.type:", action.type);
  switch (action.type) {
    case "signin_open":
      return { ...state, loggedin: false, signin: true, loaded: true, isChim: false };
    case "signin_close":
      return { ...state, signin: false };
    case "logout":
      localStorage.removeItem(LOCAL_STORE_JWT);
      return { ...initialState, loggedin: false, signin: false, loaded: true, isChim: false };
    case "login":
      return { ...state, signin: false, loggedin: true, loaded: true, isChim: true, user: action.payload.user };
    case "user_login":
      // non-chim login
      return { ...state, signin: false, loggedin: true, loaded: true, isChim: false, user: action.payload.user };
    case "anonymous":
      return { ...state, signin: false, loggedin: false, loaded: true, isChim: false, user: {} };
    case "fail":
      return { ...state, signin: false, loggedin: false, loaded: true, isChim: false, user: {} };
    default:
      return { ...state };
  }
};

function UserProvider(props) {
  let [state, dispatch] = React.useReducer(reducer, initialState);
  let value = { state, dispatch };
  return <UserContext.Provider value={value}>{props.children}</UserContext.Provider>;
}

function useUser() {
  const context = React.useContext(UserContext);
  if (context === undefined) {
    throw new Error(`useUser must be used within a UserProvider`);
  }
  return context;
}

export { UserContext, UserProvider, useUser };
